import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../../../shared/services/common.service';
import {ResourcesHubService} from '../../core/resources-hub.service';
import {v4 as uuidv4} from "uuid";
@Component({
  selector: 'app-add-accordion',
  templateUrl: './add-accordion.component.html',
  styleUrls: ['./add-accordion.component.css']
})
export class AddAccordionComponent implements OnInit {
  data: any;
  accordionModule: any[] = []

  constructor(private commonService: CommonService, private resourceHubService: ResourcesHubService) {
  }

  ngOnInit(): void {
    setTimeout(()=>{
      const accordionUuid=uuidv4();
    if (!this.data.layoutData.accordionModule) {
      const accordionModule = [{
        title: '',
        content: '',
        uuid:accordionUuid
      }]
      const updatedData = JSON.parse(JSON.stringify(this.data));
      updatedData.layoutData.accordionModule = accordionModule
      updatedData.actionType = 'initialAccordionModuleSetup'
      this.resourceHubService.sendDataToParent(updatedData);
    } else if (this.data.layoutData.accordionModule.length > 0) {
      this.accordionModule = [...this.data.layoutData.accordionModule];
    }
    },0)

    setTimeout(()=>{
      if(this.resourceHubService.lastUpdatedId.value){
        document.getElementById(this.resourceHubService.lastUpdatedId.value)?.scrollIntoView()
      }
    },0)
  }

  moveContentElementUp(index: number) {
    if (index > 0) {
      const updatedSection = JSON.parse(JSON.stringify(this.accordionModule));
      this.changeContentElementSequence(updatedSection, index, index - 1);
    }
  }

  moveContentElementDown(index: number) {
    if (index + 1 < this.accordionModule.length) {
      const updatedSection = JSON.parse(JSON.stringify(this.accordionModule));
      this.changeContentElementSequence(updatedSection, index, index + 1);
    }
  }

  changeContentElementSequence(accordionModule: any, from: number, to: number) {
    let cutOut = accordionModule.splice(from, 1) [0];
    accordionModule.splice(to, 0, cutOut);
    const updatedData = JSON.parse(JSON.stringify(this.data));
    updatedData.layoutData.accordionModule = accordionModule
    updatedData.actionType = 'initialAccordionModuleSetup'
    this.resourceHubService.sendDataToParent(updatedData);
  }

  deleteContentElement(index: number) {
    const updatedAccordionModule: any[] = [...this.accordionModule]
    updatedAccordionModule.splice(index, 1)
    const updatedData = JSON.parse(JSON.stringify(this.data));
    updatedData.layoutData.accordionModule = updatedAccordionModule
    updatedData.actionType = 'initialAccordionModuleSetup'
    this.resourceHubService.sendDataToParent(updatedData);
    this.resourceHubService.setLastUpdatedId(null)
  }

  addNewAccordion() {
    const accordionUuid=uuidv4();
    const accordion = {
      title: '',
      content: '',
      uuid: accordionUuid
    }
    const updatedAccordionModule: any[] = [...this.accordionModule]
    updatedAccordionModule.push(accordion)
    const updatedData = JSON.parse(JSON.stringify(this.data));
    updatedData.layoutData.accordionModule = updatedAccordionModule
    updatedData.actionType = 'initialAccordionModuleSetup'
    this.resourceHubService.sendDataToParent(updatedData);
    this.resourceHubService.setLastUpdatedId(accordionUuid)
  }

  onAccordionDataChange(accordionData, index: number) {
    const updatedAccordionData = JSON.parse(JSON.stringify(this.accordionModule));
    updatedAccordionData[index].title = accordionData.title
    updatedAccordionData[index].content = accordionData.content;
    // Keep local accordionModule in sync so subsequent edits build on latest data
    this.accordionModule = updatedAccordionData;
    const updatedData = JSON.parse(JSON.stringify(this.data));
    updatedData.layoutData.accordionModule = updatedAccordionData
    updatedData.actionType = 'accordionContentUpdate'
    // Clear lastUpdatedId — content-only edits should not trigger scrollIntoView
    this.resourceHubService.setLastUpdatedId(null)
    this.resourceHubService.sendDataToParent(updatedData);
  }

  trackByAccordion(index: number, item: any): string {
    return item.uuid || index.toString();
  }
}
